import { render, staticRenderFns } from "./InitialBalance.vue?vue&type=template&id=b24e8f88&scoped=true&"
import script from "./InitialBalance.vue?vue&type=script&lang=js&"
export * from "./InitialBalance.vue?vue&type=script&lang=js&"
import style0 from "./InitialBalance.vue?vue&type=style&index=0&id=b24e8f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e8f88",
  null
  
)

export default component.exports